import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { FC } from "react";
import { MuiBox, MuiButtonTertiary } from "../../../../components";
import MuiEllipseLabel from "../../../../components/ellipseLabel/MuiEllipseLabel";
import { useSiteCore } from "../../../../hooks/useSiteCore";

import { BULK_TYPE, SummaryStatus } from "../../../../helpers/constants";
import { RecordStats } from "../../../../helpers/types/common";
import { bulkActivitySiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { SUMMARY_CARD_TYPE, SummaryCard } from "../summaryCard/SummaryCard";
import {
  BulkActivityCardsWrapper,
  BulkActivityReportWrapper,
  HorizontalLine,
  VerticalDivider,
} from "./BulkActivityStatusPanel.style";

export interface BulkActivityStatusPanelProps {
  recordStatistics: RecordStats;
  processName: string;
  status: string;
  onRefresh?: () => void;
}

export const BulkActivityStatusPanel: FC<BulkActivityStatusPanelProps> = ({
  status,
  recordStatistics,
  processName,
  onRefresh,
}) => {
  const { useFetchLabel } = useSiteCore();

  const { addBulkActivitySummary, refreshStatusLink } =
    bulkActivitySiteCoreKeys;

  const getLabel = useFetchLabel(addBulkActivitySummary);

  return (
    <BulkActivityReportWrapper>
      <MuiBox>
        <MuiEllipseLabel
          text={processName}
          labelTypoVariant="h3Bold"
          labelTypoClassName="label-name-value"
        />
      </MuiBox>

      <BulkActivityCardsWrapper>
        <SummaryCard
          type={SUMMARY_CARD_TYPE.totalNumberOfPrograms}
          count={recordStatistics.total.count}
          label={recordStatistics.total.label}
          bulkType={BULK_TYPE.ACTIVITY}
        />
        <VerticalDivider />
        <SummaryCard
          type={SUMMARY_CARD_TYPE.processed}
          count={recordStatistics.processed.count}
          label={recordStatistics.processed.label}
          bulkType={BULK_TYPE.ACTIVITY}
        />

        {recordStatistics.unprocessed && (
          <>
            <VerticalDivider />
            <SummaryCard
              type={SUMMARY_CARD_TYPE.unprocessed}
              count={recordStatistics.unprocessed.count}
              label={recordStatistics.unprocessed.label}
              bulkType={BULK_TYPE.ACTIVITY}
            />
          </>
        )}
      </BulkActivityCardsWrapper>
      <HorizontalLine />
      {status === SummaryStatus.PROCESSING && onRefresh && (
        <MuiButtonTertiary
          data-testid={"summary-button-testId"}
          onClick={onRefresh}
        >
          <RefreshOutlinedIcon />
          {getLabel(refreshStatusLink)}
        </MuiButtonTertiary>
      )}
    </BulkActivityReportWrapper>
  );
};
